<template>
  <div class="view-app-download">
  </div>
</template>

<script>
export default {
  name: 'AppDownload',

  data: () => ({
  }),

  created() {
    // Se il browser è mobile, reindirizza alla pagina di download dell'app
    // Per i dispositivi iOS manda alla pagina di download dell'app su App Store
    // Per i dispositivi Android manda alla pagina di download dell'app su Google Play
    // Tutti gli altri vanno alla home
    if (this.isIOS) {
      window.location.href = 'https://apps.apple.com/it/app/keim-easy/id6457364728';
    } else if (this.isAndroid) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.keimeasy.app';
    } else {
      this.$router.replace('/');
    }
  },

  computed: {
    isIOS() {
      // Detection iOS: iPhone, iPad, iPod touch
      return /iPad|iPhone|iPod/.test(navigator.userAgent)
        && !window.MSStream; // Esclude IE11 che può matchare iPad
    },

    isAndroid() {
      // Detection Android (esclude Chrome OS che ha Android nel user agent)
      return /android/i.test(navigator.userAgent)
        && !/chrome os/i.test(navigator.userAgent);
    },
  },

  methods: {
  },
};
</script>

<style>
</style>
